var _circle, _circle2, _g, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentCmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 161,
    viewBox: "0 0 206 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9961,
    cy: 80.6855,
    r: 80,
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_631_30189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 161,
    height: 161
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.9961,
    cy: 80.6855,
    r: 80,
    fill: "#F1F2F7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_631_30189)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.0774,
    cy: 254.663,
    r: 145.671,
    fill: "#E1E3EF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9961 34.6855C70.6317 34.6855 49.9961 55.3211 49.9961 80.6855C49.9961 106.05 70.6317 126.686 95.9961 126.686C121.36 126.686 141.996 106.05 141.996 80.6855C141.996 55.3211 121.36 34.6855 95.9961 34.6855ZM132.479 76.0855H118.531C117.622 71.671 115.438 67.6199 112.25 64.4331C109.063 61.2463 105.011 59.0636 100.596 58.1547V44.2029C108.691 45.235 116.215 48.9259 121.985 54.6964C127.756 60.467 131.447 67.9903 132.479 76.0855V76.0855ZM95.9961 66.8855C103.604 66.8855 109.796 73.0771 109.796 80.6855C109.796 88.2939 103.604 94.4855 95.9961 94.4855C88.3877 94.4855 82.1961 88.2939 82.1961 80.6855C82.1961 73.0771 88.3877 66.8855 95.9961 66.8855ZM95.9961 117.486C75.7055 117.486 59.1961 100.976 59.1961 80.6855C59.1961 61.9543 73.2767 46.4799 91.3961 44.2029V58.1501C86.2054 59.2176 81.5412 62.0417 78.1896 66.1466C74.838 70.2515 73.0038 75.3862 72.9961 80.6855C72.9961 93.3677 83.3139 103.686 95.9961 103.686C101.295 103.678 106.43 101.844 110.534 98.4926C114.638 95.1408 117.461 90.4763 118.527 85.2855H132.474C130.202 103.405 114.727 117.486 95.9961 117.486Z",
    fill: "#A9A9A9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9961,
    cy: 20.6855,
    r: 8,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.996,
    cy: 126.686,
    r: 6,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9961,
    cy: 138.686,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.996,
    cy: 38.6855,
    r: 10,
    fill: "#F2F4F7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.996,
    cy: 11.6855,
    r: 7,
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.227 116.096C135.227 118.595 134.427 120.921 133.054 122.879L134.512 128.103L128.836 126.722C126.703 127.963 124.173 128.686 121.456 128.686C113.851 128.686 107.686 123.049 107.686 116.096C107.686 109.143 113.851 103.506 121.456 103.506C129.062 103.506 135.227 109.143 135.227 116.096Z",
    fill: "url(#paint0_linear_631_30189)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.914 116.095C117.914 116.964 117.21 117.669 116.341 117.669C115.472 117.669 114.767 116.964 114.767 116.095C114.767 115.226 115.472 114.521 116.341 114.521C117.21 114.521 117.914 115.226 117.914 116.095",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.633 116.095C122.633 116.964 121.928 117.669 121.059 117.669C120.19 117.669 119.485 116.964 119.485 116.095C119.485 115.226 120.19 114.521 121.059 114.521C121.928 114.521 122.633 115.226 122.633 116.095",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.145 116.095C128.145 116.964 127.44 117.669 126.571 117.669C125.702 117.669 124.997 116.964 124.997 116.095C124.997 115.226 125.702 114.521 126.571 114.521C127.44 114.521 128.145 115.226 128.145 116.095",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_30189",
    x1: 135.227,
    y1: 116.096,
    x2: 107.686,
    y2: 116.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentCmsIcon);
export default __webpack_public_path__ + "static/media/percent-cms-icon.4c4a09394c37cb43d9265087cc9ad11f.svg";
export { ForwardRef as ReactComponent };